export var EField;
(function (EField) {
    EField["Header1"] = "_header1";
    EField["Header2"] = "_header2";
    EField["Name"] = "name";
    EField["Group"] = "group";
    EField["Separator"] = "Separator";
    EField["LastSeparator"] = "lastSeparator";
})(EField || (EField = {}));
